"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("../../../core");
var event_bus_1 = require("../../../core/event-bus");
var EventBusTrait = /** @class */ (function () {
    function EventBusTrait() {
    }
    EventBusTrait.enableFor = function (instance) {
        instance._messageObserver = (function (value, topic) {
            if (instance.INTERNAL && instance.INTERNAL.isConnected) {
                instance.onMessage.call(instance, topic, value);
            }
        }).bind(instance);
        core_1.st.onMessage(event_bus_1.BUS_TOPIC_WILDCARD, instance._messageObserver);
    };
    EventBusTrait.disableFor = function (instance) {
        core_1.st.onMessageUnsubscribe(event_bus_1.BUS_TOPIC_WILDCARD, instance._messageObserver, instance);
    };
    return EventBusTrait;
}());
exports.EventBusTrait = EventBusTrait;
// import publish/subscribe
core_1.st.enable(event_bus_1.bus);
//# sourceMappingURL=event-bus.js.map